/*
 *	This list was generated by using Tēzaurs.lv open data (see: https://hdl.handle.net/20.500.12574/66)
 *	Edition used: 'Ziemas versija 2023'
 */

export const VALID_GUESSES = [
  'ABAKA',
  'ABAKS',
  'ABASS',
  'ABATE',
  'ABATS',
  'ABAZS',
  'ABĀZS',
  'ABĒJI',
  'ACOTS',
  'ACĪBA',
  'ACĪGS',
  'ACĪTE',
  'ADATA',
  'ADĀMS',
  'AERĒT',
  'AFIŠA',
  'AGAPE',
  'AGARS',
  'AGATS',
  'AGAVE',
  'AGORA',
  'AGĀMS',
  'AHAJS',
  'AHUNA',
  'AHĀTS',
  'AHŪNS',
  'AIJAS',
  'AIJĀT',
  'AILĒT',
  'AIRIS',
  'AIRĒT',
  'AKEJA',
  'AKENE',
  'AKERS',
  'AKIBA',
  'AKINS',
  'AKLIS',
  'AKOTS',
  'AKSIS',
  'AKSTS',
  'AKŪTS',
  'ALATA',
  'ALEJA',
  'ALGOT',
  'ALIBI',
  'ALISE',
  'ALIČA',
  'ALIŅŠ',
  'ALNIS',
  'ALOJA',
  'ALOJE',
  'ALOTS',
  'ALUNS',
  'ALVOT',
  'ALĒLE',
  'ALŪNS',
  'AMARA',
  'AMATS',
  'AMBRA',
  'AMILS',
  'AMIŠS',
  'AMMĀT',
  'AMOKS',
  'AMOLS',
  'AMONS',
  'AMORS',
  'AMZIS',
  'AMĀRA',
  'AMĒBA',
  'AMĪDS',
  'AMĪNS',
  'AMŪRS',
  'ANDRS',
  'ANIKA',
  'ANODS',
  'ANONA',
  'ANTRĒ',
  'ANĀLS',
  'ANĪSS',
  'AORTA',
  'APARA',
  'APART',
  'APAUT',
  'APAVS',
  'APAĻŠ',
  'APAŠS',
  'APDOT',
  'APEJA',
  'APENE',
  'APGŪT',
  'APIET',
  'APIKS',
  'APIRT',
  'APJĀT',
  'APLIS',
  'APLĪT',
  'APMĀT',
  'APMĪT',
  'APOGS',
  'APOST',
  'APPĪT',
  'APPŪT',
  'APRĀT',
  'APRĪT',
  'APSĒT',
  'APTĪT',
  'APVĪT',
  'APĒST',
  'APĻOT',
  'APŠŪT',
  'APŽŪT',
  'ARAKS',
  'ARATS',
  'AREKA',
  'ARESS',
  'AREVS',
  'ARIKS',
  'ARILS',
  'ARKLS',
  'ARODS',
  'AROMS',
  'ARTHA',
  'ARUMS',
  'ARĀBS',
  'ARĀJS',
  'ARĒJS',
  'ARĒNA',
  'ARĒNS',
  'ASAKA',
  'ASARA',
  'ASINS',
  'ASNOT',
  'ASONS',
  'ASTMA',
  'ASTRA',
  'ASTRS',
  'ASUMI',
  'ASUMS',
  'ASĪZE',
  'ATART',
  'ATAUT',
  'ATDOT',
  'ATEJA',
  'ATGŪT',
  'ATIET',
  'ATIRT',
  'ATJĀT',
  'ATLĪT',
  'ATMĀT',
  'ATMĪT',
  'ATOLS',
  'ATOMS',
  'ATPĪT',
  'ATPŪT',
  'ATRĪT',
  'ATTĪT',
  'ATVĪT',
  'ATZĪT',
  'ATĀLS',
  'ATĒNA',
  'ATŠŪT',
  'AUDZE',
  'AUGŠA',
  'AUKLA',
  'AUKLE',
  'AULIS',
  'AUROT',
  'AURĒT',
  'AUSMA',
  'AUZAS',
  'AUĻOT',
  'AUŠKA',
  'AVALS',
  'AVENE',
  'AVENS',
  'AVIZO',
  'AVOTS',
  'AVĀRS',
  'AVĪZE',
  'AZOJS',
  'AZOTE',
  'AZOTS',
  'AZĀNS',
  'AČELE',
  'AŠUMS',
  'AŠĶIS',
  'AŽŪRS',
  'BAALS',
  'BABIS',
  'BABJO',
  'BABKA',
  'BABĀT',
  'BACBU',
  'BADOT',
  'BADUS',
  'BADĪT',
  'BAENA',
  'BAFRA',
  'BAGIO',
  'BAGUA',
  'BAHTS',
  'BAHČE',
  'BAICE',
  'BAIDS',
  'BAIGA',
  'BAIGS',
  'BAIHE',
  'BAIJA',
  'BAIKA',
  'BAIKI',
  'BAIKS',
  'BAILA',
  'BAILE',
  'BAILS',
  'BAIME',
  'BAISA',
  'BAISS',
  'BAITS',
  'BAIZA',
  'BAIĻI',
  'BAIĻŠ',
  'BAIŠS',
  'BAKAS',
  'BAKAU',
  'BAKEU',
  'BAKHS',
  'BAKSS',
  'BAKĀT',
  'BALLE',
  'BALOT',
  'BALSA',
  'BALSS',
  'BALTI',
  'BALTS',
  'BALVA',
  'BALVI',
  'BALĒT',
  'BANDA',
  'BANDE',
  'BANDS',
  'BANGA',
  'BANGS',
  'BANIS',
  'BANJA',
  'BANKA',
  'BANTE',
  'BANTU',
  'BARBE',
  'BARDS',
  'BARGS',
  'BARKA',
  'BAROT',
  'BARŽA',
  'BASKS',
  'BASMA',
  'BAUDA',
  'BAUMA',
  'BAČKA',
  'BAČĀT',
  'BAĢIS',
  'BAĶES',
  'BAĶIS',
  'BAĶĒT',
  'BAĻĻA',
  'BEBRS',
  'BEDRE',
  'BEDĪT',
  'BEICE',
  'BEIGT',
  'BEIJA',
  'BEKOT',
  'BELGA',
  'BELIS',
  'BELLA',
  'BELTS',
  'BELZA',
  'BELZT',
  'BENDA',
  'BENDE',
  'BENGA',
  'BENHA',
  'BENČI',
  'BENČS',
  'BENŠA',
  'BERDA',
  'BERDE',
  'BERES',
  'BERGA',
  'BERGS',
  'BERIS',
  'BERKA',
  'BERMA',
  'BERNE',
  'BERRA',
  'BERST',
  'BERTA',
  'BERZA',
  'BERZE',
  'BERZT',
  'BERĢI',
  'BERŽI',
  'BESIS',
  'BESTS',
  'BESĪT',
  'BEŅĶE',
  'BIBIS',
  'BIEDS',
  'BIETE',
  'BIEZS',
  'BIEŽS',
  'BIKLS',
  'BIKTS',
  'BILDE',
  'BILST',
  'BINDU',
  'BINGO',
  'BIOMA',
  'BIOSS',
  'BIRDA',
  'BIRGA',
  'BIRKA',
  'BIRZE',
  'BIRZS',
  'BIRZT',
  'BIRŽA',
  'BISTE',
  'BIZOT',
  'BIČKA',
  'BLATS',
  'BLEFS',
  'BLIKS',
  'BLIŅA',
  'BLOKS',
  'BLUSA',
  'BLĀVS',
  'BLĒŅA',
  'BLĒŅI',
  'BLĪST',
  'BLĪVA',
  'BLĪVE',
  'BLĪVS',
  'BLĪZT',
  'BLŪMS',
  'BLŪZE',
  'BLŪZS',
  'BOASS',
  'BOBIS',
  'BOJĀT',
  'BOKSS',
  'BOLĪT',
  'BOMBA',
  'BOMIS',
  'BOMŽS',
  'BONDS',
  'BONZA',
  'BONĒT',
  'BORDO',
  'BORTS',
  'BOZIS',
  'BOZĒT',
  'BOČKA',
  'BRAKS',
  'BRANS',
  'BRASS',
  'BRAČA',
  'BRAŠS',
  'BRESE',
  'BRESS',
  'BREVE',
  'BREČA',
  'BRIGA',
  'BRIST',
  'BRITS',
  'BROMS',
  'BROŅA',
  'BROŠA',
  'BRUKA',
  'BRUKT',
  'BRUSA',
  'BRUTO',
  'BRĀGA',
  'BRĀZT',
  'BRĒKA',
  'BRĒKT',
  'BRĪNS',
  'BRĪVE',
  'BRĪVS',
  'BRĪZE',
  'BRŪCE',
  'BRŪNS',
  'BRŪTE',
  'BUKLĒ',
  'BUKSE',
  'BULBS',
  'BULKA',
  'BULLA',
  'BULTA',
  'BUMBA',
  'BUNCE',
  'BUNDS',
  'BUNGA',
  'BUNKA',
  'BUNTE',
  'BUNTS',
  'BURKA',
  'BURSA',
  'BURTA',
  'BURTE',
  'BURTS',
  'BURVE',
  'BURZA',
  'BURĀT',
  'BURŠS',
  'BURŽA',
  'BUSIS',
  'BUSKA',
  'BUSTE',
  'BUTKA',
  'BUZIS',
  'BUČOT',
  'BĀBOT',
  'BĀBĀT',
  'BĀDBA',
  'BĀDZE',
  'BĀDŽA',
  'BĀLĒT',
  'BĀNIS',
  'BĀRDA',
  'BĀRIS',
  'BĀZĒT',
  'BĀĶIS',
  'BĒDĀT',
  'BĒRES',
  'BĒRIS',
  'BĒRKA',
  'BĒRNS',
  'BĒROT',
  'BĒRZA',
  'BĒRZE',
  'BĒRZI',
  'BĒRZS',
  'BĒRŽI',
  'BĒSDA',
  'BĒŅAS',
  'BĪDĪT',
  'BĪTLI',
  'BĻAUT',
  'BĻODA',
  'BŪKĀT',
  'BŪRIS',
  'BŪRTE',
  'BŪSIS',
  'BŪSKA',
  'BŪSNA',
  'BŪTNE',
  'BŪVĒT',
  'BŪZIS',
  'CANGA',
  'CAUNA',
  'CAURS',
  'CEDRS',
  'CELIS',
  'CELKA',
  'CELLE',
  'CELMS',
  'CEMME',
  'CENTS',
  'CENZS',
  'CERAS',
  'CEROT',
  'CERĒT',
  'CEĻOT',
  'CIBIS',
  'CICIS',
  'CIEMS',
  'CIESA',
  'CIEST',
  'CIETE',
  'CIETS',
  'CIEŅA',
  'CIEŠS',
  'CIKLS',
  'CILME',
  'CILPA',
  'CILTS',
  'CILĀT',
  'CIMDS',
  'CINGA',
  'CINIS',
  'CINKS',
  'CIRIS',
  'CIRKS',
  'CIRPE',
  'CIRPT',
  'CIRST',
  'CIRTA',
  'CIRTE',
  'CISAS',
  'CISKA',
  'CISTA',
  'CITĒT',
  'CIZIS',
  'CIĀNA',
  'COINS',
  'COLLA',
  'CĀLIS',
  'CĒRME',
  'CĒRPS',
  'CĒRTE',
  'CĒSIS',
  'CŪKOT',
  'DABŪT',
  'DAGLA',
  'DAGLS',
  'DAIKA',
  'DAILE',
  'DAINA',
  'DAIRS',
  'DAIVA',
  'DAIĻŠ',
  'DAIŅA',
  'DAKTE',
  'DAKTS',
  'DAKŠA',
  'DALMA',
  'DALĪT',
  'DANDA',
  'DANGA',
  'DARBS',
  'DARMA',
  'DARVA',
  'DARĪT',
  'DATNE',
  'DATĒT',
  'DAUSA',
  'DAĻĢE',
  'DEJOT',
  'DELBS',
  'DELGT',
  'DELMS',
  'DELNA',
  'DELTA',
  'DENGA',
  'DENGE',
  'DERGT',
  'DERMA',
  'DERĒT',
  'DESNA',
  'DEZIS',
  'DEĢIS',
  'DEĶIS',
  'DIEBT',
  'DIEGS',
  'DIEGT',
  'DIENA',
  'DIEVE',
  'DIEVS',
  'DIKTS',
  'DILBS',
  'DILDO',
  'DILLE',
  'DIMBA',
  'DIMDA',
  'DIMDS',
  'DIMĒT',
  'DINGO',
  'DIODE',
  'DIONE',
  'DIPĒT',
  'DIRSA',
  'DIRST',
  'DISKS',
  'DIĒTA',
  'DIĒZS',
  'DOBJŠ',
  'DOCĒT',
  'DODŽS',
  'DOGMA',
  'DOINA',
  'DOKSA',
  'DOMNA',
  'DOMRA',
  'DOMĀT',
  'DONGS',
  'DONIS',
  'DONJA',
  'DONNA',
  'DORŠA',
  'DORŠS',
  'DOSJĒ',
  'DOTĒT',
  'DOZĒT',
  'DRAGA',
  'DRAPE',
  'DRAPS',
  'DRAVA',
  'DRAZA',
  'DRAŽĒ',
  'DRENA',
  'DRILS',
  'DROGA',
  'DROŠS',
  'DRUKA',
  'DRUPT',
  'DRUVA',
  'DRUZS',
  'DRĀGA',
  'DRĀMA',
  'DRĀNA',
  'DRĀTS',
  'DRĀZT',
  'DRĒBE',
  'DRĪVE',
  'DRĪZS',
  'DRŪMS',
  'DRŪZA',
  'DUATA',
  'DUBNA',
  'DUBĻI',
  'DUCIS',
  'DUETS',
  'DUKLA',
  'DUKTE',
  'DULLS',
  'DULNS',
  'DUMJŠ',
  'DUMKA',
  'DUNKA',
  'DUNĒT',
  'DUOLE',
  'DURBA',
  'DURNS',
  'DUSMA',
  'DUSĒT',
  'DUĀLS',
  'DVAKA',
  'DVARS',
  'DVAŠA',
  'DVEST',
  'DZEGA',
  'DZEJA',
  'DZELT',
  'DZENS',
  'DZERT',
  'DZETA',
  'DZIJA',
  'DZIMT',
  'DZIRA',
  'DZISA',
  'DZIST',
  'DZIĻŠ',
  'DZIŅA',
  'DZOTS',
  'DZĒSE',
  'DZĒST',
  'DZĪLE',
  'DZĪVE',
  'DZĪVS',
  'DĀNIS',
  'DĀRDS',
  'DĀRGS',
  'DĀRKS',
  'DĀRTS',
  'DĀRZS',
  'DĀSNS',
  'DĀVĀT',
  'DĀĻĀT',
  'DĒDĒT',
  'DĒLIS',
  'DĒSTS',
  'DĒVĒT',
  'DĪDĪT',
  'DĪLIS',
  'DĪRĀT',
  'DĪĶIS',
  'DŪCIS',
  'DŪDAS',
  'DŪDOT',
  'DŪDĀT',
  'DŪKOT',
  'DŪKŅA',
  'DŪLIS',
  'DŪLĒT',
  'DŪMOT',
  'DŪNIS',
  'DŪZIS',
  'DŪŅAS',
  'DŽEKS',
  'DŽEMS',
  'DŽEZS',
  'DŽINS',
  'DŽIPS',
  'DŽUDO',
  'DŽUTA',
  'DŽĪVA',
  'EBOLA',
  'ECĒŠA',
  'EDOMA',
  'EDĒMA',
  'EFEJA',
  'EFORS',
  'EGLIS',
  'EIDIS',
  'EJOŠS',
  'EKERS',
  'ELIJA',
  'ELITE',
  'ELIŅŠ',
  'ELPOT',
  'ELSAS',
  'ELSIS',
  'ELSOT',
  'ELSĀT',
  'EMERS',
  'EMĪRS',
  'EPEJS',
  'EPIKA',
  'EPOHA',
  'EPONA',
  'EPOSS',
  'EPĪRA',
  'EROSS',
  'ESEJA',
  'ESĪBA',
  'ETAPS',
  'ETILS',
  'ETĀNS',
  'ETĪDE',
  'EVENS',
  'EZERS',
  'EZĪGS',
  'EĻĻOT',
  'FAILS',
  'FAKSS',
  'FAKTS',
  'FAKUS',
  'FALLE',
  'FALLS',
  'FALŠS',
  'FANDA',
  'FANTA',
  'FANZA',
  'FARSS',
  'FARŠS',
  'FASĒT',
  'FAUNA',
  'FAUNS',
  'FAĶIS',
  'FEINS',
  'FEODS',
  'FERMA',
  'FESKA',
  'FIBRA',
  'FIDŽI',
  'FIGŅA',
  'FIKSS',
  'FILCS',
  'FILMA',
  'FINNA',
  'FIRMA',
  'FISKS',
  'FIZIS',
  'FLAGA',
  'FLORA',
  'FLORS',
  'FLOTE',
  'FLĀMS',
  'FLĪZE',
  'FOAJĒ',
  'FOGTS',
  'FOINS',
  'FOLIO',
  'FOLKS',
  'FONDS',
  'FORDS',
  'FORMA',
  'FORMS',
  'FORTS',
  'FORŠS',
  'FRAKA',
  'FRIGA',
  'FRIŠS',
  'FROTĒ',
  'FRĀZE',
  'FRĒZE',
  'FRĪZE',
  'FTĪZE',
  'FĀĶIS',
  'FĒCES',
  'FĪZIS',
  'FŪZIS',
  'GABRO',
  'GAIDA',
  'GAIDE',
  'GAILE',
  'GAISS',
  'GAIST',
  'GAITA',
  'GAIŠS',
  'GALDS',
  'GALGT',
  'GALLS',
  'GALMS',
  'GALVA',
  'GALĒT',
  'GAMMA',
  'GANGA',
  'GANĪT',
  'GARDS',
  'GARMS',
  'GAROT',
  'GARUĀ',
  'GARŠA',
  'GATVE',
  'GAUDA',
  'GAUDS',
  'GAUME',
  'GAURA',
  'GAURS',
  'GAUSA',
  'GAUSS',
  'GAUST',
  'GAUČO',
  'GAUŽS',
  'GAVĒT',
  'GAŪZA',
  'GEIMS',
  'GEIŠA',
  'GEMMA',
  'GETRA',
  'GINKS',
  'GLAZĒ',
  'GLEBA',
  'GLEJS',
  'GLEME',
  'GLEMI',
  'GLETS',
  'GLIJA',
  'GLOSA',
  'GLUDS',
  'GLUME',
  'GLUMS',
  'GLUMT',
  'GLUPS',
  'GLĀBT',
  'GLĀZE',
  'GLĪTS',
  'GLŪDA',
  'GLŪNS',
  'GLŪŅA',
  'GNOMS',
  'GNOZE',
  'GNĪDA',
  'GODĀT',
  'GOLFS',
  'GONGS',
  'GORĪT',
  'GOZĒT',
  'GRAFS',
  'GRAMS',
  'GRANS',
  'GRAPA',
  'GRAUT',
  'GRAVA',
  'GRAŽI',
  'GREBT',
  'GRIBA',
  'GRIDA',
  'GRIFS',
  'GRILS',
  'GRIMS',
  'GRIMT',
  'GRIPA',
  'GRODS',
  'GROKS',
  'GROMS',
  'GROPE',
  'GROSS',
  'GROTA',
  'GROTE',
  'GROTS',
  'GROZS',
  'GROŽI',
  'GRUPA',
  'GRĀBT',
  'GRĀDS',
  'GRĀFS',
  'GRĀJA',
  'GRĀTE',
  'GRĒDA',
  'GRĒKS',
  'GRĒVE',
  'GRĪBA',
  'GRĪDA',
  'GRĪNS',
  'GRĪVA',
  'GRĪĻŠ',
  'GRŪBA',
  'GRŪMS',
  'GRŪST',
  'GRŪTS',
  'GRŪŽS',
  'GU-JI',
  'GUAMA',
  'GUANO',
  'GUAVA',
  'GUAŠA',
  'GUBIO',
  'GUBOT',
  'GUBĀT',
  'GUBĪT',
  'GUDIS',
  'GUDRE',
  'GUDRS',
  'GUDĀT',
  'GUERA',
  'GUGOT',
  'GUIBS',
  'GUIBT',
  'GUJVA',
  'GULGA',
  'GULGT',
  'GULIS',
  'GULTA',
  'GULTE',
  'GULĒT',
  'GUMBA',
  'GUMBS',
  'GUMMA',
  'GUMPS',
  'GUMZA',
  'GUMĒT',
  'GUMŽA',
  'GUNDA',
  'GUNDU',
  'GUNĒT',
  'GUNĪT',
  'GURBA',
  'GURBS',
  'GURDE',
  'GURDS',
  'GURGT',
  'GURLS',
  'GURNS',
  'GURTA',
  'GURTE',
  'GURUE',
  'GURVA',
  'GURĶE',
  'GUSAU',
  'GUSIS',
  'GUSKA',
  'GUSNE',
  'GUSĻI',
  'GUZMA',
  'GUZNA',
  'GUĢIS',
  'GUĢOT',
  'GUĢĒT',
  'GUĪBS',
  'GUĻBA',
  'GUĻBE',
  'GUĻČA',
  'GUĻŅA',
  'GUŠŅA',
  'GUŽNO',
  'GUŽŅA',
  'GVANO',
  'GVELO',
  'GVERU',
  'GĀDĀT',
  'GĀGAS',
  'GĀGĀT',
  'GĀNĪT',
  'GĀRGT',
  'GĀRSA',
  'GĀRŠA',
  'GĀZMA',
  'GĀZME',
  'GĀZĒT',
  'GĻETS',
  'GĻIZA',
  'GĻUKS',
  'GĻĒVS',
  'GŪBOT',
  'GŪBĀT',
  'GŪBĪT',
  'GŪGLE',
  'GŪGOT',
  'GŪGĀT',
  'GŪKŠA',
  'GŪLAS',
  'GŪNĀT',
  'GŪRIS',
  'GŪROT',
  'GŪRĀT',
  'GŪSTS',
  'GŪZMA',
  'GŪZNA',
  'GŪĢIS',
  'GŪĻĀT',
  'GŪŅOT',
  'GŪŅĀT',
  'GŪŠKA',
  'HABLS',
  'HADŽS',
  'HAIFA',
  'HAIHE',
  'HAIJS',
  'HAIKA',
  'HAIKS',
  'HAIKU',
  'HAITI',
  'HAJNA',
  'HAKHA',
  'HALEO',
  'HALLA',
  'HALLE',
  'HALMA',
  'HALSA',
  'HALVA',
  'HALZE',
  'HAMBŪ',
  'HAMMA',
  'HAMSA',
  'HANDA',
  'HANJA',
  'HANKA',
  'HANKO',
  'HANNA',
  'HANNŪ',
  'HANTS',
  'HANZA',
  'HAOMA',
  'HAOSS',
  'HARFA',
  'HARFE',
  'HARNA',
  'HARTA',
  'HASKI',
  'HAURA',
  'HAUVA',
  'HAUZE',
  'HAVEA',
  'HAVKA',
  'HAVRA',
  'HAVSA',
  'HAVZA',
  'HAZRO',
  'HAŠTA',
  'HEDZE',
  'HEDŽU',
  'HEFEI',
  'HEIDE',
  'HEIHE',
  'HEILO',
  'HEISA',
  'HEITI',
  'HEJBĪ',
  'HEKLA',
  'HELGI',
  'HELIS',
  'HELLE',
  'HELMA',
  'HELMS',
  'HENDS',
  'HENGA',
  'HENNA',
  'HEPRI',
  'HERCA',
  'HERCS',
  'HERKA',
  'HERMA',
  'HERVE',
  'HERŅA',
  'HEĶIS',
  'HIDRA',
  'HIDRS',
  'HILDA',
  'HILLA',
  'HILLS',
  'HIMNA',
  'HIMSA',
  'HINDI',
  'HINDU',
  'HIPNS',
  'HIRTE',
  'HIRŠS',
  'HIĀTS',
  'HIĒNA',
  'HJŪGO',
  'HLAMS',
  'HLOCE',
  'HLORS',
  'HLUKA',
  'HNUMS',
  'HOBRO',
  'HOBSA',
  'HODKA',
  'HOHMA',
  'HOIJA',
  'HOINS',
  'HOJNA',
  'HOLDA',
  'HOLDS',
  'HOLMA',
  'HOMIS',
  'HOMSA',
  'HONDA',
  'HONDO',
  'HONSS',
  'HONTO',
  'HORDA',
  'HORJS',
  'HORNA',
  'HORVA',
  'HOSKA',
  'HOSTA',
  'HOSTS',
  'HOUČS',
  'HOVDA',
  'HOĀNA',
  'HOĶIS',
  'HRAMI',
  'HRENS',
  'HROBA',
  'HROMA',
  'HROMS',
  'HRONA',
  'HRĪSS',
  'HUEJS',
  'HUIŅA',
  'HUJVA',
  'HULDA',
  'HULKS',
  'HULLA',
  'HULMA',
  'HUNTA',
  'HUNTE',
  'HURMA',
  'HUSTA',
  'HUČVA',
  'HVANS',
  'HVARA',
  'HĀDŽS',
  'HĀILA',
  'HĀRBĪ',
  'HĀRGA',
  'HĀRKA',
  'HĀURA',
  'HĒRDE',
  'HĒSHA',
  'HĪTOT',
  'HĻEBS',
  'IBISS',
  'IBĒRE',
  'IDEJA',
  'IDIŅŠ',
  'IDUMS',
  'IEART',
  'IEAUT',
  'IEDOT',
  'IEDĒT',
  'IEEJA',
  'IEGŪT',
  'IEIET',
  'IEIRT',
  'IEJĀT',
  'IEKŠA',
  'IELĪT',
  'IEMĪT',
  'IEOST',
  'IEPĪT',
  'IEPŪT',
  'IERIS',
  'IERĪT',
  'IESMS',
  'IESĒT',
  'IETNE',
  'IETVE',
  'IETĪT',
  'IEVĪT',
  'IEZIS',
  'IEĒST',
  'IEŠŪT',
  'IEŽŪT',
  'IGREK',
  'IKARS',
  'IKONA',
  'ILGAS',
  'ILGOT',
  'ILKSS',
  'ILĪTS',
  'IMAGO',
  'IMAMS',
  'IMŪNS',
  'INCIS',
  'INDIE',
  'INDĒT',
  'INULA',
  'IRBIS',
  'IRDNE',
  'IRDNS',
  'IRSIS',
  'IRĪTS',
  'IZARA',
  'IZART',
  'IZAUT',
  'IZBŪT',
  'IZDOT',
  'IZDĒT',
  'IZEJA',
  'IZIET',
  'IZIRT',
  'IZJĀT',
  'IZLĪT',
  'IZMĪT',
  'IZOST',
  'IZPĪT',
  'IZPŪT',
  'IZRĀT',
  'IZRĪT',
  'IZSĒT',
  'IZTĪT',
  'IZVĪT',
  'IZĒST',
  'IZŠŪT',
  'IZŽŪT',
  'JAHTA',
  'JAMBS',
  'JARDS',
  'JASNA',
  'JAUDA',
  'JAUJŠ',
  'JAUKS',
  'JAUKT',
  'JAUNS',
  'JAUST',
  'JAŠMA',
  'JEZGA',
  'JOGOT',
  'JOKOT',
  'JONIS',
  'JOSLA',
  'JOSTA',
  'JOZIS',
  'JOZUA',
  'JOŅOT',
  'JUAŅA',
  'JUKAS',
  'JUMIS',
  'JUMTS',
  'JUNDA',
  'JUNGA',
  'JUPIS',
  'JURTA',
  'JURĢI',
  'JĀDĪT',
  'JĀNUS',
  'JĀŅOT',
  'JĒZUS',
  'JŪDZE',
  'JŪSMA',
  'JŪSOT',
  'JŪTAS',
  'JŪTIS',
  'KACĒT',
  'KADRS',
  'KAHTA',
  'KAIBA',
  'KAIBE',
  'KAIDS',
  'KAIFS',
  'KAIJA',
  'KAILS',
  'KAINE',
  'KAIRA',
  'KAIRE',
  'KAIRS',
  'KAIST',
  'KAITE',
  'KAIVA',
  'KAIVE',
  'KAKAO',
  'KAKLS',
  'KAKTS',
  'KAKĀT',
  'KALKS',
  'KALLA',
  'KALME',
  'KALNS',
  'KALPS',
  'KALST',
  'KALTE',
  'KALTS',
  'KALVE',
  'KAMPT',
  'KANKA',
  'KANNA',
  'KANOE',
  'KANSA',
  'KANTA',
  'KANTE',
  'KANTS',
  'KANVA',
  'KAPĀT',
  'KARDE',
  'KARDS',
  'KARGO',
  'KARKO',
  'KARKT',
  'KARMA',
  'KARNA',
  'KARNS',
  'KAROT',
  'KARPA',
  'KARPO',
  'KARST',
  'KARTE',
  'KARTS',
  'KASKA',
  'KASKO',
  'KASMA',
  'KASME',
  'KASSA',
  'KASSE',
  'KASTA',
  'KASTE',
  'KASTS',
  'KASĒT',
  'KASĪT',
  'KATLS',
  'KAUJA',
  'KAUKT',
  'KAULS',
  'KAUNS',
  'KAUPA',
  'KAURI',
  'KAUSS',
  'KAUŠS',
  'KAVRA',
  'KAVĒT',
  'KAZLA',
  'KAZLS',
  'KAZOT',
  'KAĶIS',
  'KAĶĒT',
  'KAŠIS',
  'KAŠPO',
  'KAŠĀT',
  'KAŠĒT',
  'KAŠĪT',
  'KAŠĶE',
  'KAŠŅA',
  'KAŽNS',
  'KEDRA',
  'KEIRA',
  'KERMA',
  'KERNS',
  'KINGS',
  'KIRZA',
  'KLADE',
  'KLADS',
  'KLAJS',
  'KLAJŠ',
  'KLANS',
  'KLASE',
  'KLAČA',
  'KLEŠA',
  'KLIBS',
  'KLIFS',
  'KLIJA',
  'KLIPA',
  'KLIPS',
  'KLIĶE',
  'KLONS',
  'KLUBA',
  'KLUBS',
  'KLUGA',
  'KLUPT',
  'KLUSA',
  'KLUSE',
  'KLUSS',
  'KLUST',
  'KLĀJS',
  'KLĀNS',
  'KLĀRS',
  'KLĀVS',
  'KLĒRS',
  'KLĒTS',
  'KLĪST',
  'KLŪGA',
  'KNAPS',
  'KNAŠS',
  'KNIST',
  'KNOPE',
  'KNUPT',
  'KNĀBT',
  'KNĪPA',
  'KNŪPS',
  'KOALA',
  'KOBRA',
  'KOBZA',
  'KODNE',
  'KODĒT',
  'KODĪT',
  'KOKLE',
  'KOKOT',
  'KOKSS',
  'KOKŠI',
  'KOLBA',
  'KOLIS',
  'KOLJĒ',
  'KOLTS',
  'KOMBO',
  'KOMŽA',
  'KONGA',
  'KONHA',
  'KONSS',
  'KONTS',
  'KONČA',
  'KOPNE',
  'KOPOT',
  'KOPRA',
  'KOPTS',
  'KOPĒT',
  'KORDA',
  'KORDS',
  'KORIS',
  'KORSO',
  'KORTS',
  'KOSMS',
  'KOSTE',
  'KOTKA',
  'KOTĒT',
  'KRAHS',
  'KRAMS',
  'KRASA',
  'KRASS',
  'KRAUT',
  'KRAVA',
  'KREDO',
  'KREKS',
  'KREPS',
  'KRESE',
  'KREVE',
  'KRIJA',
  'KRIKA',
  'KRILS',
  'KRIMA',
  'KRISA',
  'KRIST',
  'KROGS',
  'KROJS',
  'KROKA',
  'KRONA',
  'KROSS',
  'KRUPS',
  'KRUSA',
  'KRUTS',
  'KRUVA',
  'KRĀCE',
  'KRĀGA',
  'KRĀJA',
  'KRĀKT',
  'KRĀLS',
  'KRĀMS',
  'KRĀNS',
  'KRĀPT',
  'KRĀSA',
  'KRĀTS',
  'KRĒMS',
  'KRĒTA',
  'KRĒZS',
  'KRĪKS',
  'KRĪTS',
  'KRĪVS',
  'KRĪZE',
  'KRŪKA',
  'KRŪMS',
  'KRŪTS',
  'KRŪZA',
  'KRŪZE',
  'KUBLS',
  'KUHŅA',
  'KUKAI',
  'KUKŅA',
  'KULBA',
  'KULDA',
  'KULTA',
  'KULTS',
  'KUMPA',
  'KUMPS',
  'KUMPT',
  'KUNGS',
  'KUNIS',
  'KUPLS',
  'KUPRS',
  'KUPĒT',
  'KURDS',
  'KURKT',
  'KURLS',
  'KURPE',
  'KURSS',
  'KURTS',
  'KUSIS',
  'KUSLS',
  'KUTĒT',
  'KUĢIS',
  'KUĢOT',
  'KUĻĀT',
  'KVAGA',
  'KVAPA',
  'KVARA',
  'KVASS',
  'KVAČA',
  'KVIPA',
  'KVOTA',
  'KVĒLE',
  'KVĒLS',
  'KVĒPS',
  'KVĒPT',
  'KVĪTS',
  'KĀJOT',
  'KĀLIS',
  'KĀMIS',
  'KĀMĒT',
  'KĀPES',
  'KĀRBA',
  'KĀRES',
  'KĀRKT',
  'KĀRNS',
  'KĀROT',
  'KĀRPA',
  'KĀRST',
  'KĀRTA',
  'KĀRTS',
  'KĀSIS',
  'KĀSĒT',
  'KĀSĪT',
  'KĀTOT',
  'KĀTĀT',
  'KĀZAS',
  'KĀZOT',
  'KĀĶIS',
  'KĒKSS',
  'KĻAUT',
  'KĻAVA',
  'KĻAVS',
  'KĻOŠS',
  'KĻŪDA',
  'KĻŪME',
  'KĻŪMS',
  'KŅADA',
  'KŅAZE',
  'KŅAZS',
  'KŅUPT',
  'KŅĪPA',
  'KŪDRA',
  'KŪDĪT',
  'KŪKOT',
  'KŪLIS',
  'KŪLOT',
  'KŪPĒT',
  'KŪRIS',
  'KŪSIS',
  'KŪSOT',
  'KŪSĀT',
  'KŪSĒT',
  'KŪTRS',
  'KŪVĒT',
  'KŪĻĀT',
  'KŪŅOT',
  'LABOT',
  'LABĒT',
  'LABĪT',
  'LACIO',
  'LACIS',
  'LACĪT',
  'LAGOA',
  'LAGOT',
  'LAIDA',
  'LAIDE',
  'LAIDS',
  'LAIKA',
  'LAIKS',
  'LAIME',
  'LAIMS',
  'LAIPA',
  'LAIST',
  'LAIVA',
  'LAIŽA',
  'LAKOT',
  'LAKTA',
  'LAMAS',
  'LAMPA',
  'LAMĀT',
  'LANDO',
  'LANGO',
  'LANKA',
  'LAPOT',
  'LAPSA',
  'LAPTA',
  'LASIS',
  'LASTS',
  'LASĪT',
  'LATOT',
  'LAUCE',
  'LAUKI',
  'LAUKS',
  'LAUMA',
  'LAURA',
  'LAURS',
  'LAUTA',
  'LAUVA',
  'LAUZA',
  'LAUZT',
  'LAVĒT',
  'LAZDA',
  'LAĶĒT',
  'LEDOT',
  'LEDUS',
  'LEIDA',
  'LEINS',
  'LEKNS',
  'LELLE',
  'LELOT',
  'LEMKI',
  'LEMMA',
  'LENCE',
  'LENKT',
  'LENTA',
  'LENTE',
  'LEONE',
  'LEPNS',
  'LEPRA',
  'LEPĒT',
  'LEĢĒT',
  'LEĶĒT',
  'LIBRA',
  'LIDOT',
  'LIECE',
  'LIEGS',
  'LIEGT',
  'LIEKS',
  'LIEKT',
  'LIELS',
  'LIEPA',
  'LIESA',
  'LIESS',
  'LIETA',
  'LIFTS',
  'LIKME',
  'LIKRA',
  'LILLĀ',
  'LIMBS',
  'LIMFA',
  'LINGA',
  'LINČA',
  'LIPSI',
  'LISTE',
  'LITRS',
  'LIZDA',
  'LIĀNA',
  'LIĢĒT',
  'LJANA',
  'LOBĒT',
  'LOBĪT',
  'LOCIS',
  'LOCĪT',
  'LODĀT',
  'LODĒT',
  'LOIDS',
  'LOLOT',
  'LONĒT',
  'LONŽA',
  'LORDS',
  'LOZĒT',
  'LOŽŅA',
  'LOŽŅU',
  'LUCIS',
  'LUESS',
  'LUKNS',
  'LUKSS',
  'LUKTA',
  'LULOT',
  'LUNGS',
  'LUNKA',
  'LUSTE',
  'LĀBIS',
  'LĀCIS',
  'LĀDĒT',
  'LĀGOT',
  'LĀKTE',
  'LĀKTS',
  'LĀMOT',
  'LĀNIS',
  'LĀPOT',
  'LĀPĪT',
  'LĀSMA',
  'LĀSOT',
  'LĀSTS',
  'LĀSĒT',
  'LĀČOT',
  'LĀČĀT',
  'LĒKME',
  'LĒKTS',
  'LĒKĀT',
  'LĒKŠI',
  'LĒLIS',
  'LĒNIS',
  'LĒPIS',
  'LĒŅOT',
  'LĪBIS',
  'LĪCIS',
  'LĪDĒT',
  'LĪGOT',
  'LĪKNE',
  'LĪKĀT',
  'LĪMĒT',
  'LĪNIS',
  'LĪSTE',
  'LĪTŅA',
  'LĪVIS',
  'LĪČOT',
  'LĪĶIS',
  'LĪŅĀT',
  'LŪKOT',
  'LŪKŠA',
  'LŪLOT',
  'LŪRĒT',
  'LŪSIS',
  'LŪŽŅA',
  'MAGMA',
  'MAIGS',
  'MAIJA',
  'MAIJS',
  'MAIKO',
  'MAINS',
  'MAISS',
  'MAITA',
  'MAIZE',
  'MAIŅA',
  'MAKAO',
  'MAKSA',
  'MALDS',
  'MALKA',
  'MALKS',
  'MALME',
  'MALTA',
  'MALVA',
  'MAMBA',
  'MAMBO',
  'MAMMA',
  'MANDU',
  'MANGA',
  'MANGO',
  'MANKO',
  'MANNA',
  'MANSS',
  'MANTA',
  'MANTO',
  'MANTŪ',
  'MANĪT',
  'MAORS',
  'MARGA',
  'MARKA',
  'MARLE',
  'MARSS',
  'MARTS',
  'MARŠS',
  'MARŽA',
  'MASKA',
  'MASTS',
  'MASĒT',
  'MATOT',
  'MATČA',
  'MATĒT',
  'MATĪT',
  'MAUKT',
  'MAURS',
  'MEDIO',
  'MEDOT',
  'MEDUS',
  'MEDĪT',
  'MEIJA',
  'MEITA',
  'MEIČA',
  'MELIS',
  'MELNS',
  'MELOT',
  'MELST',
  'MELŠA',
  'MEMME',
  'MENCA',
  'MENGE',
  'MENTE',
  'MENTS',
  'MERGA',
  'MESJĒ',
  'MESLI',
  'METRO',
  'METRS',
  'MIECE',
  'MIEGS',
  'MIEGT',
  'MIERS',
  'MIESA',
  'MIETS',
  'MIGLA',
  'MIKAS',
  'MIKLS',
  'MILNA',
  'MILNS',
  'MILTI',
  'MILTS',
  'MILZE',
  'MILZT',
  'MILZU',
  'MINKA',
  'MINĒT',
  'MIOMA',
  'MIONS',
  'MIOZE',
  'MIRGA',
  'MIRIS',
  'MIRKT',
  'MIRLA',
  'MIRRE',
  'MIRTE',
  'MISIS',
  'MITRA',
  'MITRS',
  'MIZOT',
  'MIĀZE',
  'MIČOT',
  'MOCĪT',
  'MODRE',
  'MODRS',
  'MOIRA',
  'MOIVA',
  'MOKAS',
  'MOLLS',
  'MONGO',
  'MONTS',
  'MORGS',
  'MORIS',
  'MORSS',
  'MORVI',
  'MORZE',
  'MOSIS',
  'MOZUS',
  'MOZĒT',
  'MOŠUS',
  'MUARĒ',
  'MUDRS',
  'MUDĪT',
  'MUITA',
  'MUIŽA',
  'MUKLS',
  'MULDA',
  'MULLA',
  'MULSA',
  'MULSS',
  'MULST',
  'MULČA',
  'MUMIO',
  'MUMJO',
  'MURDS',
  'MURGS',
  'MURZA',
  'MUTĒT',
  'MUĶIS',
  'MUĻĶA',
  'MUĻĶS',
  'MUĻĻA',
  'MUŠĪT',
  'MĀCĒT',
  'MĀCĪT',
  'MĀJOT',
  'MĀLIS',
  'MĀLĒT',
  'MĀNIS',
  'MĀNĪT',
  'MĀRKA',
  'MĀRKS',
  'MĀRŠA',
  'MĒDĪT',
  'MĒGLE',
  'MĒRCE',
  'MĒRIS',
  'MĒRKT',
  'MĒROT',
  'MĒRĪT',
  'MĒSLS',
  'MĒTRA',
  'MĒTĀT',
  'MĒĻOT',
  'MĪCĪT',
  'MĪDĪT',
  'MĪKLA',
  'MĪLIS',
  'MĪLĒT',
  'MĪNĒT',
  'MĪTNE',
  'MĪĻOT',
  'MĪŅĀT',
  'MŪDĪT',
  'MŪLIS',
  'MŪRIS',
  'MŪRĒT',
  'MŪĶIS',
  'MŪĶĒT',
  'NAFTA',
  'NAGLA',
  'NAIDS',
  'NAIGS',
  'NAIRA',
  'NAIVS',
  'NAKRA',
  'NAKTS',
  'NANDU',
  'NANNA',
  'NAOSS',
  'NARVI',
  'NASKS',
  'NASTA',
  'NAUDA',
  'NAUJŠ',
  'NAZIS',
  'NAŠIS',
  'NAŽOT',
  'NEASS',
  'NELGA',
  'NEONS',
  'NERCS',
  'NERRS',
  'NERVS',
  'NEĻĶE',
  'NIEKS',
  'NIERE',
  'NIEVA',
  'NIEZE',
  'NIKNS',
  'NIMBS',
  'NIMFA',
  'NINNA',
  'NIĶIS',
  'NOARA',
  'NOART',
  'NOASS',
  'NOAUT',
  'NOBLS',
  'NODOT',
  'NOEJA',
  'NOIET',
  'NOIRT',
  'NOJĀT',
  'NOLĪT',
  'NOMĀT',
  'NOMĪT',
  'NOPĪT',
  'NOPŪT',
  'NORGE',
  'NORMA',
  'NORĀT',
  'NORĪT',
  'NOSĒT',
  'NOTĪT',
  'NOVĪT',
  'NOĒST',
  'NOŠŪT',
  'NOŽŪT',
  'NTAIS',
  'NULLE',
  'NURSE',
  'NĀRŠU',
  'NĀTNS',
  'NĀTRA',
  'NĀTRE',
  'NĀVĒT',
  'NĒRST',
  'NĒSIS',
  'NĒSĀT',
  'NĒĢIS',
  'NĪDĒT',
  'NĪGRS',
  'NĪTĒT',
  'NĪTĪT',
  'NŪJOT',
  'NŪNIS',
  'NŪĢIS',
  'OBOJA',
  'ODERE',
  'ODESA',
  'ODZIS',
  'OFISS',
  'OFĪRA',
  'OGĀJS',
  'OKERS',
  'OLIŅA',
  'OLĀJS',
  'OLĪVA',
  'OLĪVE',
  'OMARS',
  'OMEGA',
  'OMONS',
  'OMĀRS',
  'OMĪGS',
  'ONIJA',
  'OPAPS',
  'OPERA',
  'OPIJS',
  'OPTĒT',
  'OPUSS',
  'OPĀLS',
  'ORBIS',
  'ORIGO',
  'ORPĒT',
  'ORĀLS',
  'OSTĪT',
  'OSĀJS',
  'OTAVA',
  'OTĪTS',
  'OVĀLS',
  'OZENA',
  'OZOLS',
  'OZONS',
  'OZĒNA',
  'OĀZIS',
  'OĻĀJS',
  'OŠŅĀT',
  'PAART',
  'PAASS',
  'PAAUT',
  'PABŪT',
  'PADOT',
  'PADĒT',
  'PAGŪT',
  'PAIET',
  'PAIJA',
  'PAIKA',
  'PAIRT',
  'PAIST',
  'PAJĀT',
  'PAKOT',
  'PAKTS',
  'PALGS',
  'PALMA',
  'PALMO',
  'PALOT',
  'PALSS',
  'PALTS',
  'PALĪT',
  'PAMPA',
  'PAMPT',
  'PAMĀT',
  'PAMĪT',
  'PANGA',
  'PANKS',
  'PANNA',
  'PANNO',
  'PANTS',
  'PANĒT',
  'PAOST',
  'PAPUS',
  'PAPŪT',
  'PARKA',
  'PARKS',
  'PARSS',
  'PARTI',
  'PARĀT',
  'PARĪT',
  'PASHA',
  'PASTA',
  'PASTS',
  'PASĒT',
  'PATIO',
  'PATĪT',
  'PAUDA',
  'PAUGA',
  'PAUNA',
  'PAURE',
  'PAUSA',
  'PAUST',
  'PAUTS',
  'PAUZE',
  'PAVĪT',
  'PAZĪT',
  'PAĒNA',
  'PAĒST',
  'PAĪGT',
  'PAĪSS',
  'PAĻAS',
  'PAĻĀT',
  'PAŠŪT',
  'PAŽŪT',
  'PEANS',
  'PEKLE',
  'PEKĀT',
  'PELDE',
  'PELDU',
  'PELNI',
  'PELUS',
  'PELĒT',
  'PENGA',
  'PENIS',
  'PENSI',
  'PENTA',
  'PEONS',
  'PERMS',
  'PERSS',
  'PERĒT',
  'PERŠA',
  'PERŠS',
  'PEĀNS',
  'PEĻOT',
  'PEĻĶE',
  'PEĻŅA',
  'PEŅŅA',
  'PIALA',
  'PICKA',
  'PIENS',
  'PIEPE',
  'PIERA',
  'PIERE',
  'PIETS',
  'PIETĀ',
  'PIEŅI',
  'PIKOT',
  'PIKTS',
  'PIKĀT',
  'PIKĒT',
  'PIKŠA',
  'PILNS',
  'PILĒT',
  'PINKA',
  'PINNE',
  'PINTE',
  'PIONS',
  'PIPKA',
  'PIRKT',
  'PIRRS',
  'PIRST',
  'PIRTS',
  'PITKA',
  'PIĶIS',
  'PIĶOT',
  'PIĶĒT',
  'PJERO',
  'PJEZA',
  'PLADA',
  'PLADE',
  'PLAKT',
  'PLATE',
  'PLATO',
  'PLATS',
  'PLAŠS',
  'PLECS',
  'PLEDS',
  'PLENE',
  'PLESA',
  'PLEST',
  'PLIKS',
  'PLISĒ',
  'PLOVS',
  'PLUKT',
  'PLUSS',
  'PLUČI',
  'PLĀNS',
  'PLĀTE',
  'PLĀTS',
  'PLĀVA',
  'PLĒKA',
  'PLĒNE',
  'PLĒSA',
  'PLĒST',
  'PLĒVE',
  'PLĒŠA',
  'PLĪST',
  'PLĪTS',
  'PLĪVA',
  'PLĪŠS',
  'PLŪDI',
  'PLŪKT',
  'PLŪME',
  'PLŪST',
  'PLŪČI',
  'POCIS',
  'POGOT',
  'POGĀT',
  'POIŠA',
  'POLIS',
  'POLKA',
  'POMPA',
  'PONČO',
  'POPĒT',
  'PORĒT',
  'PORŠS',
  'POSMS',
  'POSTS',
  'POSĀT',
  'POTĒT',
  'POZĒT',
  'POĒMA',
  'POĢIS',
  'PRAST',
  'PRAŠA',
  'PRECE',
  'PRESE',
  'PROFS',
  'PROSA',
  'PROVE',
  'PROZA',
  'PRĀNA',
  'PRĀTS',
  'PRĀVA',
  'PRĀVS',
  'PRĪMA',
  'PRĪZE',
  'PSIHE',
  'PSIHS',
  'PTOZE',
  'PUAZS',
  'PUCĒT',
  'PUIKA',
  'PULKA',
  'PULKS',
  'PULPA',
  'PULSS',
  'PULTS',
  'PULĒT',
  'PUMPA',
  'PUNKS',
  'PUNŠS',
  'PURGA',
  'PURNS',
  'PURVS',
  'PUTAS',
  'PUTNS',
  'PUTOT',
  'PUTRA',
  'PUTTI',
  'PUTĒT',
  'PUĢIS',
  'PUŠĶE',
  'PĀLIS',
  'PĀRIS',
  'PĀROT',
  'PĒDOT',
  'PĒLIS',
  'PĒRLE',
  'PĒRNS',
  'PĒTĪT',
  'PĪCKA',
  'PĪPIS',
  'PĪPOT',
  'PĪPĒT',
  'PĪTNE',
  'PĪĶIS',
  'PĻAUT',
  'PĻAVA',
  'PĻERA',
  'PĻĀPA',
  'PŪDĒT',
  'PŪDŽA',
  'PŪKOT',
  'PŪLES',
  'PŪLIS',
  'PŪSMA',
  'PŪĶIS',
  'PŪŠĻA',
  'RABBI',
  'RABĀT',
  'RACIS',
  'RADIO',
  'RADZE',
  'RADĪT',
  'RAGUS',
  'RAIBS',
  'RAITS',
  'RAIZE',
  'RAKĀT',
  'RAMPA',
  'RANDS',
  'RANDU',
  'RANGS',
  'RANKS',
  'RANČO',
  'RASMA',
  'RASOT',
  'RASĒT',
  'RAUDA',
  'RAUDS',
  'RAUGI',
  'RAUGS',
  'RAUKT',
  'RAUST',
  'RAUTS',
  'RAVĒT',
  'RAŽOT',
  'REBES',
  'RECĒT',
  'REDZE',
  'REIBA',
  'REIBS',
  'REIBT',
  'REIDS',
  'REIHS',
  'REIKI',
  'REISS',
  'REIZE',
  'REKTE',
  'RENGA',
  'RENTE',
  'REPIS',
  'REPĒT',
  'RESIS',
  'RESNS',
  'RESTE',
  'RETRO',
  'REĀLS',
  'REĢIS',
  'REŅĢE',
  'RIDĀT',
  'RIEBA',
  'RIEBT',
  'RIEKS',
  'RIEPA',
  'RIEST',
  'RIETI',
  'RIETS',
  'RIEVA',
  'RIEZT',
  'RIEŽA',
  'RIKŠA',
  'RIMTA',
  'RIMTS',
  'RINDA',
  'RINGS',
  'RINKS',
  'RIPOT',
  'RIPSS',
  'RISKS',
  'RISĒT',
  'RITMS',
  'RITĒT',
  'RIVNE',
  'RIĀLS',
  'RIĶIS',
  'RO-RO',
  'ROBOT',
  'ROBĪT',
  'ROCIS',
  'RODEO',
  'ROMBS',
  'RONDO',
  'RONIS',
  'ROSMA',
  'ROSME',
  'ROTĀT',
  'ROTĒT',
  'ROTĪT',
  'ROVIS',
  'ROZIS',
  'ROĶIS',
  'RUDOT',
  'RUDZI',
  'RUDĒT',
  'RUKĀT',
  'RUMBA',
  'RUMBS',
  'RUNGA',
  'RUNĀT',
  'RUPJŠ',
  'RUSTE',
  'RUSTS',
  'RUTKS',
  'RUZGS',
  'RUĪNA',
  'RUŠKA',
  'RUŠĶE',
  'RĀCIS',
  'RĀDZE',
  'RĀDĪT',
  'RĀDŽA',
  'RĀMIS',
  'RĀMĪT',
  'RĀPOT',
  'RĀTNS',
  'RĒDES',
  'RĒDZE',
  'RĒGOT',
  'RĒTOT',
  'RĒVĒT',
  'RĒZUS',
  'RĪBĒT',
  'RĪDZE',
  'RĪDĪT',
  'RĪKLE',
  'RĪKOT',
  'RĪLIS',
  'RĪMĒT',
  'RĪVĒT',
  'RŪCIS',
  'RŪDĪT',
  'RŪGTS',
  'RŪKOT',
  'RŪKĀT',
  'RŪNĪT',
  'RŪPĒT',
  'RŪSGS',
  'RŪSOT',
  'RŪSĒT',
  'RŪTOT',
  'RŪZGS',
  'RŪĶIS',
  'RŪŽAS',
  'SAART',
  'SAAUT',
  'SABRE',
  'SABŪT',
  'SACĪT',
  'SADKO',
  'SADOT',
  'SADĒT',
  'SAGŠA',
  'SAIDA',
  'SAIET',
  'SAIGA',
  'SAIME',
  'SAIRA',
  'SAIRT',
  'SAITE',
  'SAIVA',
  'SAJĀT',
  'SAKAS',
  'SAKNE',
  'SAKTA',
  'SAKĻA',
  'SAKŠA',
  'SALDO',
  'SALDS',
  'SALKT',
  'SALMS',
  'SALNA',
  'SALNS',
  'SALTO',
  'SALTS',
  'SALĪT',
  'SAMBA',
  'SAMBO',
  'SAMTS',
  'SAMĪT',
  'SANGA',
  'SANĒT',
  'SAOST',
  'SAPĪT',
  'SAPŪT',
  'SARGS',
  'SARKT',
  'SARMA',
  'SARĀT',
  'SARĪT',
  'SARĶE',
  'SARŽS',
  'SASIS',
  'SASĒT',
  'SATĪT',
  'SAUJA',
  'SAUKT',
  'SAULE',
  'SAUNA',
  'SAUSS',
  'SAVĪT',
  'SAĒST',
  'SAĪGT',
  'SAŠŪT',
  'SAŽŪT',
  'SCĒNA',
  'SECĒT',
  'SEDLI',
  'SEGLI',
  'SEIFS',
  'SEIJA',
  'SEIMS',
  'SEIŠA',
  'SEKAS',
  'SEKLE',
  'SEKLS',
  'SEKOT',
  'SEKSS',
  'SEKTA',
  'SELGA',
  'SELJE',
  'SELKE',
  'SELVA',
  'SENCE',
  'SENNA',
  'SENTS',
  'SENČA',
  'SEPSE',
  'SERBS',
  'SERDE',
  'SERSO',
  'SERVE',
  'SESKS',
  'SFĒNS',
  'SFĒRA',
  'SHĒMA',
  'SHĪMA',
  'SIALS',
  'SIDRS',
  'SIEKS',
  'SIENA',
  'SIENS',
  'SIERS',
  'SIETS',
  'SIEVA',
  'SIGMA',
  'SIJĀT',
  'SILFS',
  'SILTS',
  'SIMTS',
  'SINTI',
  'SIRDS',
  'SIRGT',
  'SIRMS',
  'SIRMT',
  'SIROT',
  'SISIS',
  'SISLA',
  'SIĻĶE',
  'SJĒNA',
  'SKADI',
  'SKALA',
  'SKALS',
  'SKARA',
  'SKART',
  'SKATE',
  'SKATS',
  'SKAUT',
  'SKAVA',
  'SKAĻŠ',
  'SKAŅA',
  'SKAŅŠ',
  'SKEČS',
  'SKICE',
  'SKIFS',
  'SKIRS',
  'SKITS',
  'SKOLA',
  'SKOPS',
  'SKOSA',
  'SKOTS',
  'SKUBA',
  'SKUJA',
  'SKUMT',
  'SKURA',
  'SKUĶE',
  'SKĀBE',
  'SKĀBS',
  'SKĀBT',
  'SKĀDE',
  'SKĀRE',
  'SKĀŅS',
  'SKĀŅŠ',
  'SKĒNA',
  'SLABS',
  'SLAKA',
  'SLAVA',
  'SLEJA',
  'SLIDA',
  'SLIET',
  'SLIMS',
  'SLIPS',
  'SLITA',
  'SLOGS',
  'SLOKA',
  'SLONS',
  'SLOTA',
  'SLĀBS',
  'SLĀBT',
  'SLĀPT',
  'SLĀVS',
  'SLĒGS',
  'SLĒGT',
  'SLĒNE',
  'SLĒPE',
  'SLĒPT',
  'SLĪDE',
  'SLĪGT',
  'SLĪKT',
  'SLĪPE',
  'SLĪPS',
  'SLŪPE',
  'SMAGS',
  'SMAKA',
  'SMAKT',
  'SMELT',
  'SMEŠS',
  'SMIET',
  'SMITE',
  'SMOGS',
  'SMUKS',
  'SMĒDE',
  'SMĒRE',
  'SMĒRS',
  'SMĒĶE',
  'SMĪLA',
  'SMĪNS',
  'SNIGT',
  'SNOBS',
  'SODĪT',
  'SOLDO',
  'SOLIS',
  'SOLĪT',
  'SONGS',
  'SOPKA',
  'SORBS',
  'SORGO',
  'SOTŅA',
  'SOĢIS',
  'SOĻOT',
  'SPALS',
  'SPARE',
  'SPARS',
  'SPECS',
  'SPERT',
  'SPICE',
  'SPICS',
  'SPINS',
  'SPIRA',
  'SPOKS',
  'SPOLE',
  'SPORA',
  'SPOŽS',
  'SPURA',
  'SPURT',
  'SPĀRE',
  'SPĒJA',
  'SPĒJŠ',
  'SPĒKS',
  'SPĒLE',
  'SPĪDE',
  'SPĪLE',
  'SPĪTS',
  'SPĪVE',
  'SPĪVS',
  'SPĪČS',
  'STABS',
  'STAKS',
  'STARA',
  'STARS',
  'STATS',
  'STAĢE',
  'STEKS',
  'STENA',
  'STENO',
  'STENS',
  'STEPE',
  'STEPS',
  'STERS',
  'STIBA',
  'STIGA',
  'STIGT',
  'STILS',
  'STILT',
  'STOLA',
  'STOLS',
  'STOMA',
  'STONS',
  'STOPS',
  'STORE',
  'STOTS',
  'STUKS',
  'STUMT',
  'STUPA',
  'STUPE',
  'STUPS',
  'STUTE',
  'STĀDS',
  'STĀJA',
  'STĀVS',
  'STĀZE',
  'STĀŽS',
  'STĒLA',
  'STĒLE',
  'STĪGA',
  'STĪGT',
  'STĪPA',
  'STĪVS',
  'STŪPA',
  'STŪRE',
  'STŪRS',
  'SUFLĒ',
  'SUITS',
  'SUKĀT',
  'SULOT',
  'SUMMA',
  'SUNNA',
  'SUNĪT',
  'SUSLA',
  'SUSĒT',
  'SUTRA',
  'SUĶIS',
  'SVAMI',
  'SVARI',
  'SVARS',
  'SVECE',
  'SVEDA',
  'SVELT',
  'SVENS',
  'SVEĶI',
  'SVEŠS',
  'SVILT',
  'SVINS',
  'SVIRA',
  'SVĒLE',
  'SVĒLS',
  'SVĒRT',
  'SVĒTS',
  'SVĪRE',
  'SVĪST',
  'SVĪTA',
  'SĀBRS',
  'SĀDŽA',
  'SĀKAS',
  'SĀLĪT',
  'SĀPĒT',
  'SĀRMS',
  'SĀRTS',
  'SĀRĶE',
  'SĀRŅI',
  'SĒBRS',
  'SĒDĒT',
  'SĒKLA',
  'SĒKĀT',
  'SĒLIS',
  'SĒRAS',
  'SĒRFS',
  'SĒRGA',
  'SĒROT',
  'SĒRST',
  'SĒŅOT',
  'SĪLIS',
  'SŪBĒT',
  'SŪKĀT',
  'SŪNOT',
  'SŪRME',
  'SŪRMS',
  'SŪTĪT',
  'TABLO',
  'TACIS',
  'TAFTS',
  'TAHTA',
  'TAIGA',
  'TAIRA',
  'TAKSE',
  'TAKTS',
  'TALKA',
  'TALKS',
  'TALLO',
  'TALMA',
  'TALSI',
  'TANGO',
  'TANIS',
  'TANKA',
  'TANKS',
  'TANTE',
  'TAPOT',
  'TARBA',
  'TAROT',
  'TARTU',
  'TARĀT',
  'TARĒT',
  'TAUJA',
  'TAUKI',
  'TAUKS',
  'TAURE',
  'TAURS',
  'TAUTA',
  'TAUVA',
  'TAČKA',
  'TAĻJA',
  'TAĻĻA',
  'TECĒT',
  'TEHNO',
  'TEIKA',
  'TEIKT',
  'TEIPS',
  'TEKNE',
  'TEKSS',
  'TEKĀT',
  'TELPA',
  'TELTS',
  'TEMPS',
  'TEMPT',
  'TENKA',
  'TENTS',
  'TEPĒT',
  'TERCA',
  'TERMA',
  'TERMS',
  'TESLA',
  'TESTS',
  'TETRS',
  'TEĪNS',
  'TEĶIS',
  'TICIS',
  'TICĒT',
  'TIECE',
  'TIEPT',
  'TIESA',
  'TIEVS',
  'TIEŠS',
  'TIKLS',
  'TILDE',
  'TILLS',
  'TILPE',
  'TILPT',
  'TILTS',
  'TIMPA',
  'TIMSA',
  'TINGS',
  'TINIS',
  'TINTE',
  'TIONE',
  'TIRKS',
  'TIRPA',
  'TIRPT',
  'TIRSA',
  'TITRS',
  'TIZLS',
  'TIĀRA',
  'TOLIS',
  'TONDO',
  'TONIS',
  'TONNA',
  'TONĒT',
  'TORRS',
  'TORSS',
  'TORTE',
  'TOSTS',
  'TRAKS',
  'TRAMS',
  'TRANS',
  'TRAPS',
  'TRASE',
  'TRASS',
  'TRATA',
  'TREBŪ',
  'TREKS',
  'TREME',
  'TRESE',
  'TRIBA',
  'TRICE',
  'TRIKO',
  'TRIKS',
  'TRIMO',
  'TRIMS',
  'TRIPS',
  'TROGS',
  'TROJA',
  'TRONA',
  'TROPS',
  'TROSE',
  'TRUBA',
  'TRULS',
  'TRUMS',
  'TRUPA',
  'TRUPE',
  'TRUPT',
  'TRĀNS',
  'TRĒNS',
  'TRĪCE',
  'TRĪSA',
  'TRŪCE',
  'TRŪDE',
  'TRŪDS',
  'TRŪKT',
  'TUKLS',
  'TUKŠS',
  'TULIS',
  'TULKS',
  'TULPE',
  'TUMBA',
  'TUMSA',
  'TUMST',
  'TUMĒT',
  'TUMŠS',
  'TUNGA',
  'TUPĒT',
  'TURAS',
  'TURBO',
  'TURKS',
  'TURZA',
  'TURĒT',
  'TUZIS',
  'TUŠĒT',
  'TVANS',
  'TVERT',
  'TVĪDS',
  'TVĪKA',
  'TVĪKT',
  'TVĪTS',
  'TĀMĒT',
  'TĀRPS',
  'TĒBAS',
  'TĒLOT',
  'TĒMĒT',
  'TĒRCE',
  'TĒRPS',
  'TĒRPT',
  'TĒRĒT',
  'TĒTIS',
  'TĪKLS',
  'TĪKOT',
  'TĪNIS',
  'TĪRĪT',
  'TĪŅĀT',
  'TŪCĪT',
  'TŪSKA',
  'UBAGS',
  'UCINS',
  'UGUNS',
  'UKAZS',
  'ULURU',
  'ULĀNS',
  'UMBRA',
  'UMBRS',
  'UPENE',
  'URBIS',
  'URDZE',
  'URDĒT',
  'URDĪT',
  'URGOT',
  'URRĀT',
  'URĀNS',
  'URĀTS',
  'URĪMS',
  'URĪNS',
  'URĶIS',
  'URĶĒT',
  'UTENE',
  'UVĀLS',
  'UZACS',
  'UZART',
  'UZAUT',
  'UZDOT',
  'UZEJA',
  'UZIET',
  'UZINA',
  'UZJĀT',
  'UZLĪT',
  'UZMĪT',
  'UZOST',
  'UZPĪT',
  'UZSĒT',
  'UZTĪT',
  'UZUSS',
  'UZVĪT',
  'UZĒST',
  'UZŠŪT',
  'UČENE',
  'UČUKS',
  'VADĀT',
  'VADĪT',
  'VAGOT',
  'VAIDS',
  'VAIGS',
  'VAIKS',
  'VAINA',
  'VAJĀT',
  'VAKTS',
  'VALDE',
  'VALDS',
  'VALGS',
  'VALIS',
  'VALKS',
  'VANNA',
  'VANNE',
  'VANTA',
  'VANTE',
  'VANTS',
  'VANVA',
  'VAPNA',
  'VARDE',
  'VARZA',
  'VARĒT',
  'VASKS',
  'VATĒT',
  'VAZĀT',
  'VAĻĪT',
  'VAŅKA',
  'VAŽOT',
  'VECIS',
  'VECOT',
  'VECĒT',
  'VEDGA',
  'VEDRS',
  'VEIDS',
  'VEIKT',
  'VELCE',
  'VELGA',
  'VELGS',
  'VELGT',
  'VELIS',
  'VELKS',
  'VELLS',
  'VELME',
  'VELNS',
  'VELTE',
  'VELTS',
  'VELVE',
  'VELĒT',
  'VENDS',
  'VEPSS',
  'VERBS',
  'VERGA',
  'VERGS',
  'VESTE',
  'VEČKA',
  'VEĢIS',
  'VICOT',
  'VIDEO',
  'VIDUS',
  'VIEBT',
  'VIEDS',
  'VIELA',
  'VIEST',
  'VIETA',
  'VIKSE',
  'VILCE',
  'VILGS',
  'VILGT',
  'VILKS',
  'VILKT',
  'VILLA',
  'VILNA',
  'VILTS',
  'VIMBA',
  'VINDA',
  'VINTS',
  'VINČA',
  'VIOLA',
  'VIRBA',
  'VIRCA',
  'VIRGA',
  'VIRMA',
  'VIRPA',
  'VIRSA',
  'VIRST',
  'VIRTE',
  'VIRVE',
  'VIRZA',
  'VIRZE',
  'VIRĀT',
  'VISTA',
  'VISTS',
  'VIZLA',
  'VIZMA',
  'VIZOT',
  'VIZĒT',
  'VIĻĀT',
  'VJETU',
  'VOBLA',
  'VOLTA',
  'VOLTE',
  'VOLTS',
  'VOLVO',
  'VRAKS',
  'VULVA',
  'VUŠKA',
  'VĀJĒT',
  'VĀKOT',
  'VĀLOT',
  'VĀLĒT',
  'VĀPLA',
  'VĀPĒT',
  'VĀRDS',
  'VĀRGS',
  'VĀRGT',
  'VĀRNA',
  'VĀRPA',
  'VĀRTI',
  'VĀRĒT',
  'VĀRĪT',
  'VĀĢIS',
  'VĀĶĒT',
  'VĀĻĀT',
  'VĒDĪT',
  'VĒJOT',
  'VĒLME',
  'VĒLĒT',
  'VĒMAS',
  'VĒRIS',
  'VĒROT',
  'VĒRPE',
  'VĒRPT',
  'VĒRST',
  'VĒRTE',
  'VĒRTS',
  'VĒSMA',
  'VĒSTS',
  'VĒTRA',
  'VĒTĪT',
  'VĒZDA',
  'VĒZIS',
  'VĒZĒT',
  'VĒŽOT',
  'VĪDĒT',
  'VĪKNE',
  'VĪKŠT',
  'VĪLĒT',
  'VĪSLA',
  'VĪTNE',
  'VĪTĒT',
  'VĪĶIS',
  'VĪŽOT',
  'ZADĒT',
  'ZAIGA',
  'ZAIGS',
  'ZAIMS',
  'ZAIRA',
  'ZAKSS',
  'ZALGS',
  'ZALVE',
  'ZAMPA',
  'ZARNA',
  'ZAROT',
  'ZAURS',
  'ZAVĒT',
  'ZAĶIS',
  'ZAĻGS',
  'ZAĻOT',
  'ZAĻĒT',
  'ZEBRA',
  'ZEIJA',
  'ZELTS',
  'ZELĒT',
  'ZEMĒT',
  'ZIBĒT',
  'ZIEDE',
  'ZIEDS',
  'ZIEGS',
  'ZIEMA',
  'ZIEST',
  'ZIEĶE',
  'ZILBE',
  'ZILGA',
  'ZILGS',
  'ZILGT',
  'ZILOT',
  'ZILĒT',
  'ZIMZA',
  'ZIMZE',
  'ZINTE',
  'ZINTS',
  'ZINĀT',
  'ZIRGS',
  'ZIŅOT',
  'ZIŅĢE',
  'ZLOTS',
  'ZNOTS',
  'ZOBOT',
  'ZOLĒT',
  'ZONDE',
  'ZONĒT',
  'ZORBS',
  'ZOSĒT',
  'ZUMĒT',
  'ZUTIS',
  'ZUZĒT',
  'ZVANS',
  'ZVAŅA',
  'ZVEJA',
  'ZVEJS',
  'ZVELT',
  'ZVILT',
  'ZVĒRE',
  'ZVĒRS',
  'ZVĪLE',
  'ZVĪĻŠ',
  'ZVĪŅA',
  'ZĀKAS',
  'ZĀKĀT',
  'ZĀLES',
  'ZĀRDS',
  'ZĀRKS',
  'ZĀĢIS',
  'ZĀĢĒT',
  'ZĀĻOT',
  'ZĪDĪT',
  'ZĪLĒT',
  'ZĪMĒT',
  'ZĪĻOT',
  'ZŪZIS',
  'ĀBECE',
  'ĀBELE',
  'ĀBOLS',
  'ĀDERE',
  'ĀDIŅA',
  'ĀKLIS',
  'ĀKSTS',
  'ĀLAVA',
  'ĀLAVS',
  'ĀLIŅŠ',
  'ĀMURS',
  'ĀPSIS',
  'ĀRDIS',
  'ĀRDĒT',
  'ĀRDĪT',
  'ĀRIJA',
  'ĀRSTS',
  'ĀRUMS',
  'ĀRĒJS',
  'ĀRĪGS',
  'ĀZIJA',
  'ĀĶĪGS',
  'ČABĒT',
  'ČADRA',
  'ČAGAS',
  'ČAGĀT',
  'ČAKLS',
  'ČALMA',
  'ČALOT',
  'ČARKA',
  'ČARKI',
  'ČATNI',
  'ČAUGS',
  'ČAULA',
  'ČELLO',
  'ČELLS',
  'ČIEPT',
  'ČILLI',
  'ČIPOT',
  'ČIPSS',
  'ČIPĒT',
  'ČOINS',
  'ČUBAS',
  'ČUHŅA',
  'ČUKČS',
  'ČULGA',
  'ČUMĒT',
  'ČUPRS',
  'ČURĀT',
  'ČUČĒT',
  'ČUŠĻI',
  'ČĀPOT',
  'ČĀPĀT',
  'ČĀZIS',
  'ČĪGĀT',
  'ČŪLOT',
  'ČŪLĀT',
  'ČŪSKA',
  'ĒDAMS',
  'ĒDĀJS',
  'ĒDĒJS',
  'ĒRCIS',
  'ĒSLIS',
  'ĒTERS',
  'ĒTIKA',
  'ĒVELE',
  'ĒŠANA',
  'ĢEMZE',
  'ĢEĶIS',
  'ĢIFTS',
  'ĢIKTS',
  'ĢILDE',
  'ĢINTS',
  'ĢĒLES',
  'ĢĒRBS',
  'ĢĒRBT',
  'ĢĒRĒT',
  'ĢĪGĀT',
  'ĢĪMIS',
  'ĪGNĒT',
  'ĪLENS',
  'ĪLIJA',
  'ĪNIJA',
  'ĪNUMS',
  'ĪPATS',
  'ĪPAŠS',
  'ĪRISS',
  'ĪSUMS',
  'ĶEIRE',
  'ĶELLE',
  'ĶELTS',
  'ĶEMME',
  'ĶEPĒT',
  'ĶERRA',
  'ĶERTS',
  'ĶESKA',
  'ĶETNA',
  'ĶEĢIS',
  'ĶIDAS',
  'ĶIDĀT',
  'ĶILDA',
  'ĶIPIS',
  'ĶIRPA',
  'ĶITĒT',
  'ĶOBIS',
  'ĶOCIS',
  'ĶOĶIS',
  'ĶĒDĒT',
  'ĶĒKŠA',
  'ĶĒPĀT',
  'ĶĒRKT',
  'ĶĒRNE',
  'ĶĒRSA',
  'ĶĒSIS',
  'ĶĒZĪT',
  'ĶĒĶIS',
  'ĶĪLIS',
  'ĶĪLĀT',
  'ĶĪLĒT',
  'ĶĪRIS',
  'ĶĪSIS',
  'ĶĪĶIS',
  'ĶĪĶĒT',
  'ĶŪLIS',
  'ĻAUJA',
  'ĻAUNS',
  'ĻECKA',
  'ĻEIDA',
  'ĻEKAS',
  'ĻEKOT',
  'ĻEKĀT',
  'ĻEPOT',
  'ĻERBA',
  'ĻERGA',
  'ĻEZGA',
  'ĻIPOT',
  'ĻUMĒT',
  'ĻURBA',
  'ĻVIVA',
  'ĻĒPOT',
  'ŅAMMA',
  'ŅAUDA',
  'ŅENCS',
  'ŅERGA',
  'ŅIPRS',
  'ŅIRBA',
  'ŅIRBT',
  'ŅIRGA',
  'ŅIRGT',
  'ŅJOKI',
  'ŅUKĀT',
  'ŅURGA',
  'ŅURĪT',
  'ŅUŅŅA',
  'ŠAHTA',
  'ŠAIBA',
  'ŠAKTI',
  'ŠALKA',
  'ŠALKT',
  'ŠALLE',
  'ŠALTE',
  'ŠALTS',
  'ŠANCE',
  'ŠARMS',
  'ŠARŽS',
  'ŠAURS',
  'ŠAUST',
  'ŠEIBE',
  'ŠEIHS',
  'ŠEIKS',
  'ŠELFS',
  'ŠENGS',
  'ŠERPS',
  'ŠEVRO',
  'ŠIFRS',
  'ŠIHTA',
  'ŠINĒT',
  'ŠIRAS',
  'ŠIZIS',
  'ŠIĪTS',
  'ŠLAGA',
  'ŠLEPE',
  'ŠLIFS',
  'ŠLIHS',
  'ŠMATS',
  'ŠMĪGA',
  'ŠNEKS',
  'ŠNORE',
  'ŠOKĒT',
  'ŠORTI',
  'ŠOSĒT',
  'ŠPAGA',
  'ŠPATS',
  'ŠPICS',
  'ŠPIKS',
  'ŠPOKS',
  'ŠROTS',
  'ŠRĀGA',
  'ŠTAGA',
  'ŠTATS',
  'ŠTIHS',
  'ŠTIKS',
  'ŠTOKS',
  'ŠTORA',
  'ŠTĀBS',
  'ŠUNTS',
  'ŠURFS',
  'ŠVAKS',
  'ŠVĪGA',
  'ŠVĪKA',
  'ŠVĪTS',
  'ŠĀLIS',
  'ŠĶELT',
  'ŠĶILA',
  'ŠĶILT',
  'ŠĶIRA',
  'ŠĶIRT',
  'ŠĶIST',
  'ŠĶORE',
  'ŠĶĒLE',
  'ŠĶĒPS',
  'ŠĶĒRI',
  'ŠĶĪBS',
  'ŠĶĪST',
  'ŠĶŪRE',
  'ŠĻAKA',
  'ŠĻUKA',
  'ŠĻUKT',
  'ŠĻUTE',
  'ŠĻĀCE',
  'ŠĻĀKT',
  'ŠĻŪCE',
  'ŠĻŪDE',
  'ŠĻŪKT',
  'ŠŅORE',
  'ŠŅĀKA',
  'ŠŅĀKT',
  'ŠŅĀPT',
  'ŠŅĪPA',
  'ŠŪPAS',
  'ŠŪPOT',
  'ŪBELE',
  'ŪDELE',
  'ŪDENS',
  'ŪKŠĒT',
  'ŪNIJA',
  'ŪPĒNS',
  'ŪRIJA',
  'ŪVULA',
  'ŪZIŅA',
  'ŽAGAS',
  'ŽAGOT',
  'ŽAMPA',
  'ŽANRS',
  'ŽAUNA',
  'ŽESTS',
  'ŽIGLS',
  'ŽILBA',
  'ŽILBS',
  'ŽILBT',
  'ŽIRĒT',
  'ŽMOGS',
  'ŽOMPA',
  'ŽULGA',
  'ŽULGS',
  'ŽULGT',
  'ŽULTS',
  'ŽURGA',
  'ŽURKA',
  'ŽĀKLE',
  'ŽĀVAS',
  'ŽĀVĒT',
  'ŽĒLAS',
  'ŽĒLOT',
  'ŽŪPOT',
  'ŽŪRĒT',
  'ŽŪŽOT',
]
